import { jsx as _jsx } from "react/jsx-runtime";
import { PremiumSourceLimitWarningContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/components/PremiumSourceLimitWarning.js';
/**
 * @deprecated Legacy `AskInput` wrapper. Remove when the `AskInput` Composer migration is complete.
 */
export function PremiumSourceLimitWarning({ isFollowUp, }) {
    return _jsx(PremiumSourceLimitWarningContent, { isFollowUp: isFollowUp, hasBottomSpacing: true });
}
//# sourceMappingURL=PremiumSourceLimitWarning.js.map